var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusThickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51587 9.15366L14.2205 9.15361C14.5174 9.15386 14.7585 8.90806 14.7582 8.60539C14.7582 8.30247 14.5176 8.05719 14.2205 8.05719L8.51588 8.05725L8.51593 2.24073C8.51593 1.9378 8.27537 1.69252 7.97827 1.69252C7.68143 1.69227 7.44035 1.93807 7.4406 2.24074L7.44055 8.05726L1.73589 8.05731C1.43904 8.05705 1.19797 8.30286 1.19822 8.60552C1.19821 8.75698 1.25855 8.89397 1.35589 8.99322C1.45323 9.09247 1.58733 9.15372 1.73588 9.15372L7.44054 9.15367L7.44049 14.9702C7.44049 15.1217 7.50082 15.2586 7.59816 15.3579C7.6955 15.4571 7.8296 15.5184 7.97815 15.5184C8.27499 15.5186 8.51607 15.2728 8.51582 14.9702L8.51587 9.15366Z",
    fill: "#5B5166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51587 9.15366L14.2205 9.15361C14.5174 9.15386 14.7585 8.90806 14.7582 8.60539C14.7582 8.30247 14.5176 8.05719 14.2205 8.05719L8.51588 8.05725L8.51593 2.24073C8.51593 1.9378 8.27537 1.69252 7.97827 1.69252C7.68143 1.69227 7.44035 1.93807 7.4406 2.24074L7.44055 8.05726L1.73588 8.05731C1.43904 8.05705 1.19797 8.30286 1.19822 8.60552C1.19821 8.75698 1.25855 8.89397 1.35589 8.99322C1.45323 9.09247 1.58733 9.15372 1.73588 9.15372L7.44054 9.15367L7.44049 14.9702C7.44049 15.1217 7.50082 15.2586 7.59816 15.3579C7.6955 15.4571 7.8296 15.5184 7.97815 15.5184C8.27499 15.5186 8.51607 15.2728 8.51582 14.9702L8.51587 9.15366",
    stroke: "#5B5166",
    strokeWidth: 2.17468
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusThickIcon);
export default __webpack_public_path__ + "static/media/plusThickIcon.6ab95c715e3db075eab073f97030e6a1.svg";
export { ForwardRef as ReactComponent };